(() => {
  angular
    .module('complianceFrameworkApp.complianceForums')
    .controller('ComplianceForumsTopNavController', ComplianceForumsTopNavController);

  /* ngInject */
  function ComplianceForumsTopNavController($state, config, sessionService) {
    const vm = this;

    vm.logOut = logOut;
    vm.user = sessionService.getUser();
    vm.userAvatarUrl = config.complianceFrameworkApiEndpoint + sessionService.getUser().avatar_url;

    function logOut() {
      sessionService.destroySession();
      $state.go('unauthenticated.login');
    }
  }

})();
